export const purgeSpecialChars = (str) => {
  if (!str) return "";
  return str.replace(/[^a-zA-Z0-9]/g, "");
};
